import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { media } from 'designsystem/index';
import ds from 'designsystem';

const ButtonContainer = styled.div`
  width: ${ds.get('metrics.m')};
  height: ${ds.get('metrics.s')};
  position: fixed;
  top: ${ds.get('metrics.s')};
  right: ${ds.get('metrics.s')};
  display: flex;
  align-items: center;

  ${media.tablet`
    top: ${ds.get('metrics.m')};
    right: ${ds.get('metrics.l')};
  `}

  &:focus {
    outline: none;
  }
`;

const Button = styled.span`
  cursor: pointer;
  &::before, &::after {
    content: '';
    position: absolute;
    height: 2px;
    width: calc(${ds.get('metrics.base')} / 2);
    top: 50%;
    right: 0;
    background: ${ds.brand('regular')};
  }

  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }
`;

const Text = styled.span`
  font-size: ${ds.fs('m')};
  line-height: ${ds.get('type.lineHeight.s')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.extended')};
  cursor: pointer;
  position: absolute;
  top: -3px;
  right: 0;
  opacity: 0;
  transition: all .3s;
  ${({ active }) => active && css`
    right: ${ds.get('metrics.base')};
    opacity: 1;
  `};
`;

const CloseButton = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  text,
  isShown,
}) => (
  <ButtonContainer
    onClick={onClick}
    onKeyPress={onClick}
    role="button"
    tabIndex={-1}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <Button />
    <Text active={isShown}>{text}</Text>
  </ButtonContainer>
);


CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  text: PropTypes.string,
  isShown: PropTypes.bool,
};
CloseButton.defaultProps = {
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  text: '',
  isShown: false,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/blocks/CloseButton/index.jsx